export const transition = {
    PRIMARY: 'all 250ms ease-in-out'
}